class ModalElement extends HTMLElement {
  static observedAttributes = ['aria-hidden']
  constructor () {
    super()

    this.triggerEls = document.querySelectorAll('[data-modal-trigger]')
    this.closeEls = this.querySelectorAll('[data-el="modal-element.close"]')
    this.overlay = this.querySelector('[data-el="modal-element.overlay"]')

    document.addEventListener(
      'keyup',
      event => event.code.toUpperCase() === 'ESCAPE' && this.close(),
    )

    this.triggerEls.forEach(triggerEl =>
      triggerEl.addEventListener('click', this.open.bind(this)),
    )

    this.closeEls.forEach(closeEl =>
      closeEl.addEventListener('click', this.close.bind(this)),
    )

    this.overlay.addEventListener('click', this.close.bind(this))
  }

  attributeChangedCallback (name, oldValue, newValue) {
    if (oldValue === newValue) return
    if (this.dataset.modal === 'size-guide') return

    if (name === 'aria-hidden' && newValue === 'false') {
      this.querySelectorAll('img').forEach(img => {
        img.src = img.dataset.src
        if (img.hasAttribute('srcset')) {
          img.srcset = img.dataset.srcset
        }
      })

      this.querySelectorAll('.rsp-Image_Zoom').forEach(zoomEl => {
        zoomEl.style.backgroundImage = `url(${zoomEl.dataset.url})`
      })
    }
  }

  open (event) {
    if (event.currentTarget.dataset.modalTrigger === this.dataset.modal) {
      this.setAttribute('aria-hidden', 'false')
    }
  }

  close () {
    this.setAttribute('aria-hidden', 'true')
  }
}

customElements.define('modal-element', ModalElement)
